module.exports = __webpack_public_path__ + "img/isr.58e1cbb6.svg";